import { Controller } from "@hotwired/stimulus";
import { useDebounce } from "stimulus-use";

export default class extends Controller {
  static targets = ["input"];
  static values = { debounce: { type: Number, default: 250 } };
  static debounces = ["_submit"];

  connect() {
    useDebounce(this, { wait: this.debounceValue });
  }

  changed() {
    if (!this.hasInputTarget) {
      this.inputTarget = this.element.querySelector("input[name='q']");
    }

    this._submit();
  }

  _submit() {
    const input = this.hasInputTarget
      ? this.inputTarget
      : this.element.querySelector("input[name='q']");

    if (input && window.history && window.history.replaceState && window.URL) {
      const q = input.value || "";
      const url = new URL(window.location.href);

      if (q.trim() === "") {
        url.searchParams.delete("q");
      } else {
        url.searchParams.set("q", q);
      }

      window.history.replaceState({}, "", url.toString());
    }

    if (typeof this.element.requestSubmit === "function") {
      this.element.requestSubmit();
    } else {
      this.element.submit();
    }
  }
}
